import { groupBy } from 'lodash'
import moment from 'moment'
import type { ReactElement } from 'react'
import { VisitRow } from './CalendarVisit'
import type { AppointmentsCalendarState } from './useAppointmentsCalendar'

/** The day or week on a phone: one list in time order, grouped by day, provider on every line. */
export function CalendarAgenda({ calendar }: { calendar: AppointmentsCalendarState }): ReactElement {
  const byDay = groupBy(calendar.visits, (visit) => visit.day)
  const days = calendar.range.days.filter((day) => byDay[day]?.length)

  return (
    <div className="min-h-0 flex-1 overflow-y-auto rounded-lg border border-default bg-surface">
      {days.map((day) => (
        <section key={day}>
          {/* The toolbar already names a lone day and the summary counts it. */}
          {calendar.view !== `day` && (
            <h4 className="sticky top-0 z-10 flex items-baseline justify-between border-b border-default bg-surface-subtle px-3 py-2 text-body-sm font-semibold text-strong">
              {moment(day).format(`dddd, MMM D`)}
              <span className="text-body-xs font-normal tabular-nums text-subtle">
                {byDay[day].length} {byDay[day].length === 1 ? `visit` : `visits`}
              </span>
            </h4>
          )}
          <div className="p-1">
            {byDay[day].map((visit) => (
              <VisitRow key={visit.appointment.id} visit={visit} calendar={calendar} withProvider />
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
